import type { FollowUpChanges } from '@/modules/infringements/components/infringement-follow-up'
import { useOnErrorAuto } from '@/utils/hooks'
import { useMutation } from '@apollo/client'
import { PATCH_WORK_INFRINGEMENT } from '../mutations'

export function usePatchWorkInfringement(id: string) {
  const onErrorAuto = useOnErrorAuto()
  const [patch, { loading }] = useMutation(PATCH_WORK_INFRINGEMENT, {
    awaitRefetchQueries: true,
    refetchQueries: ['WorkDayInfringement', 'AllCombinedInfringements'],
    onError: onErrorAuto(),
  })
  return {
    loading,
    onPatch: (changes: FollowUpChanges) =>
      patch({ variables: { id, ...changes } }),
  }
}
